import { render } from "./PageHeader.vue?vue&type=template&id=6e410674&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=6e410674&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/d72e10b2-82a4-4871-b4ef-3f0bf96be7c1/workspace/site-h5_3HZM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e410674"]])

export default __exports__